<div class="page-size">
    <p-dropdown
        [options]="pageSizes"
        [disabled]="!recordsTotal || recordsTotal <= 10"
        optionLabel="label"
        optionValue="value"
        styleClass="filter page-size"
        [(ngModel)]="pageSize"
        (onChange)="onPageSizeChange($event)"
    ></p-dropdown>
</div>